var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowUpCombo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8389 13.0892C16.5135 13.4147 15.9859 13.4147 15.6604 13.0892L9.99967 7.42849L4.33893 13.0892C4.01349 13.4147 3.48585 13.4147 3.16042 13.0892C2.83498 12.7638 2.83498 12.2362 3.16042 11.9107L9.41042 5.66072C9.73586 5.33529 10.2635 5.33529 10.5889 5.66072L16.8389 11.9107C17.1644 12.2362 17.1644 12.7638 16.8389 13.0892Z",
    fill: "#353A41"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpCombo);
export default __webpack_public_path__ + "static/media/arrow-up-combo.5871e2e7037bd88b93c6d7e0463f582a.svg";
export { ForwardRef as ReactComponent };